import React from 'react';
import Appbar from 'components/appbar/Appbar';
import SpecialtyAction from './SpecialtyAction';
import PageHeaderActions from 'components/page-header/PageHeaderActions';
import NewRecordButton from 'components/page-header/NewRecordButton';
import { useFetchSpecialties } from './hooks/useFetchSpecialties';
import SpecialtyFilterBox from './SpecialtyFilterBox';
import Pagination from 'components/pagination/Pagination';
import SpecialtyListTable from './list/table/SpecialtyListTable';
import SpecialtyListModule from './list/module/SpecialtyListModule';
import { useDisplayMode } from 'hooks/useDisplayMode';
import PaginationProvider from 'hooks/pagination';
import TableLoading from 'components/loading/TableLoading';
import ModuleLoading from 'components/loading/ModuleLoading';
import NoData from 'components/no-data/NoData';

const Specialty: React.FC = () => {
  const {
    specialties,
    loading,
    orderedIndex,
    handleSort,
    filter,
    handleChange,
    setPage,
    setRows,
    handleSearch,
    page,
    rows,
    total,
  } = useFetchSpecialties();
  const [displayMode] = useDisplayMode();
  return (
    <>
      <Appbar title="Especialidades" ActionsComponent={<SpecialtyAction />} />
      <PageHeaderActions
        title="Especialidades"
        description="Gestão de especialidades"
        ActionComponent={<NewRecordButton label="Nova especialidade" to="/specialties/new" />}
      />

      <SpecialtyFilterBox filter={filter} handleChange={handleChange} handleSearch={handleSearch} loading={loading} />

      <PaginationProvider rowsPerPage={rows}>
        {loading ? (
          displayMode === 'list' ? (
            <TableLoading />
          ) : (
            <ModuleLoading />
          )
        ) : specialties.length === 0 ? (
          <NoData message="Nenhuma especialidade encontrada" />
        ) : (
          <>
            {displayMode === 'list' ? (
              <SpecialtyListTable handleSearch={handleSearch} specialties={specialties} />
            ) : (
              <SpecialtyListModule handleSearch={handleSearch} specialties={specialties} />
            )}

            <Pagination
              count={total}
              currentPage={page}
              currentRowsPerPage={rows}
              onChangePage={page => setPage(page)}
              onChangeRowsPerPage={rows => setRows(rows)}
            />
          </>
        )}
      </PaginationProvider>
    </>
  );
};

export default Specialty;
